import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import ZoomControls from "@/Components/DocumentModal/ZoomControls";

const ViewerToolbar = ({
  searchTerm,
  onSearchChange,
  searchProgress,
  pageNumber = 1,
  totalPages,
  onGoToPage,
  zoom,
  onZoomChange,
  isChatOpen = false,
}) => {
  const [isFocus, setIsFocus] = useState(false);

  const handleChangePageNumber = (event) => {
    const next = Number(event.target.value);
    if (next >= 1 && next <= totalPages) onGoToPage(next);
  };

  return (
    <div
      className="pdftoolbar  p-l-5 p-r-5 align-items-center m-0"
      style={{ height: "25px", background: "var(--primary)" }}
    >
      <div className="col-md-3 col-lg-5 col-xl-6 col-xxl-7 p-0 d-flex align-items-center">
        <div
          className="input-row d-flex-1 p-l-5 min-width-search-document-popup"
          style={{ height: "21px", maxWidth: "600px", marginRight: "5px", minWidth: "50px" }}
        >
          <input
            type="text"
            className="form-control height-21 document-search-text-color"
            placeholder="Type Search Terms to Only Display Pages With Those Terms"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            onFocus={() => setIsFocus(true)}
            onBlur={() => setIsFocus(false)}
            style={{
              height: "21px",
              fontWeight: "600",
              color: isFocus ? "var(--primary)" : "var(--primary-25)",
            }}
          />
        </div>
        {/* Page text is now extracted on demand rather than at open, so a
            first search over a long document takes a moment. Only shown while
            that walk is running. */}
        {searchProgress?.isSearching && (
          <span
            className="document-search-text-color"
            style={{
              fontSize: "11px",
              fontWeight: "600",
              whiteSpace: "nowrap",
              marginRight: "5px",
            }}
          >
            Searching… {searchProgress.done}/{searchProgress.total}
          </span>
        )}
        <div
          className="center-controls d-flex align-items-center justify-content-center ms-auto"
          style={{ gap: "5px" }}
        >
          <button
            onClick={() => onGoToPage(pageNumber - 1)}
            disabled={pageNumber <= 1}
            style={{ height: "21px", padding: 0, margin: 0, minWidth: "25px", width: "25px" }}
            className="d-flex align-items-center justify-content-center btns-bottom-bar-document-popup"
          >
            <FaChevronUp size={18} style={{ color: "#009900" }} />
          </button>
          <input
            id="pageno"
            className="pageno form-control p-0 color-main"
            value={pageNumber}
            onChange={handleChangePageNumber}
            min="1"
            max={totalPages}
            style={{ height: "21px", fontWeight: "600", minWidth: "40px", maxWidth: "60px" }}
          />
          <button
            onClick={() => onGoToPage(pageNumber + 1)}
            disabled={pageNumber >= totalPages}
            style={{ height: "21px", padding: 0, margin: 0, minWidth: "25px", width: "25px" }}
            className="d-flex align-items-center justify-content-center btns-bottom-bar-document-popup"
          >
            <FaChevronDown size={18} style={{ color: "#009900" }} />
          </button>
        </div>
      </div>

      <ZoomControls onZoomChange={onZoomChange} zoomScale={zoom} isChatOpen={isChatOpen} />
    </div>
  );
};

export default ViewerToolbar;
